var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHeaderParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1221 11.6639V8.23849H11.919C12.1842 8.23849 12.4395 8.25983 12.685 8.30251C12.9304 8.3452 13.1465 8.43056 13.333 8.55861C13.5196 8.67599 13.6669 8.84673 13.7749 9.07082C13.8928 9.29491 13.9517 9.58836 13.9517 9.95117C13.9517 10.314 13.8928 10.6074 13.7749 10.8315C13.6669 11.0556 13.5196 11.2317 13.333 11.3597C13.1465 11.4771 12.9304 11.5571 12.685 11.5998C12.4395 11.6425 12.1842 11.6639 11.919 11.6639H10.1221ZM7.80957 6.28571V17.7143H10.1221V13.6166H12.5524C13.2103 13.6166 13.77 13.5153 14.2315 13.3125C14.693 13.0991 15.0662 12.8217 15.351 12.4802C15.6455 12.1387 15.8567 11.7492 15.9843 11.3117C16.1218 10.8635 16.1905 10.41 16.1905 9.95117C16.1905 9.48165 16.1218 9.02814 15.9843 8.59063C15.8567 8.15312 15.6455 7.76363 15.351 7.42216C15.0662 7.08069 14.693 6.80858 14.2315 6.60583C13.77 6.39242 13.2103 6.28571 12.5524 6.28571H7.80957Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeaderParking);
export default __webpack_public_path__ + "static/media/ic_header_parking.9ce815158bfb9d4a906ed3fd9bd3d9c2.svg";
export { ForwardRef as ReactComponent };